var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMoneyflow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 16.1667V8.83333C19.5 7.825 18.675 7 17.6667 7H4.83333C3.825 7 3 7.825 3 8.83333V16.1667C3 17.175 3.825 18 4.83333 18H17.6667C18.675 18 19.5 17.175 19.5 16.1667ZM19.5 16.1667H4.83333V8.83333H17.6667H19.5V16.1667ZM11.25 9.75C9.72833 9.75 8.5 10.9783 8.5 12.5C8.5 14.0217 9.72833 15.25 11.25 15.25C12.7717 15.25 14 14.0217 14 12.5C14 10.9783 12.7717 9.75 11.25 9.75Z",
    fill: "#37288E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2496 12.5287L21.139 14.0403",
    stroke: "#37288E",
    strokeWidth: 1.375,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2436 12.5286L21.133 11.012",
    stroke: "#37288E",
    strokeWidth: 1.375,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2495 12.4446L16.75 12.4446",
    stroke: "#37288E",
    strokeWidth: 1.375,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoneyflow);
export default __webpack_public_path__ + "static/media/moneyflow.f6111f40.svg";
export { ForwardRef as ReactComponent };